import { XCircleIcon } from "@heroicons/react/20/solid";

export function ErrorAlert({ text }: { text: string }) {
	return (
		<div className="yF-rounded-md yF-bg-red-50 yF-p-4 yF-mt-2">
			<div className="yF-flex">
				<div className="yF-flex-shrink-0">
					<XCircleIcon
						className="yF-h-5 w-5 yF-text-red-400"
						aria-hidden="true"
					/>
				</div>
				<div className="yF-ml-3">
					<h3 className="yF-text-sm !yF-my-0 yF-font-medium yF-text-red-800">
						{text}
					</h3>
				</div>
			</div>
		</div>
	);
}
